/**
 * 中文翻译
 */
const zh = {
  // 通用
  common: {
    confirm: '确定',
    cancel: '取消',
    close: '关闭',
    copy: '复制',
    copied: '已复制',
    clear: '清空',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '提示',
  },

  // 导航
  nav: {
    brand: 'DevToolkit',
    brandSubtitle: '开发者工具箱',
    json: 'JSON 格式化',
    jsonDesc: 'JSON 解析、格式化和查看',
    timestamp: '时间戳',
    timestampDesc: 'Unix 时间戳与日期时间转换',
    gostruct: 'Go ↔ JSON',
    gostructDesc: 'Go 结构体与 JSON 互转',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    systemMode: '跟随系统',
    github: 'GitHub',
    language: '语言',
  },

  // 页脚
  footer: {
    brand: 'DevToolkit',
    subtitle: '开发者工具箱',
    github: 'GitHub',
    feedback: '反馈建议',
    copyright: '© 2025 DevToolkit',
  },

  // JSON 工具
  json: {
    // 标签页
    tabs: {
      newTab: '新建标签',
      closeTab: '关闭标签',
      rename: '重命名',
      closeOthers: '关闭其他标签',
      closeRight: '关闭右侧标签',
      closeLeft: '关闭左侧标签',
      maxTabsAlert: '最多支持 {max} 个标签页',
      confirmCloseOthers: '确定要关闭其他 {count} 个标签吗？',
      confirmCloseRight: '确定要关闭右侧 {count} 个标签吗？',
      confirmCloseLeft: '确定要关闭左侧 {count} 个标签吗？',
      defaultName: 'Tab {num}',
    },

    // 工具栏
    toolbar: {
      history: '历史',
      table: '表格',
      tree: '树状',
      expandAll: '全部展开',
      collapseAll: '全部折叠',
      clear: '清空',
    },

    // 输入区
    input: {
      title: '输入 JSON',
      placeholder: '在此粘贴或输入 JSON...',
      expandInput: '展开输入',
    },

    // 视图
    view: {
      treeView: '树状视图',
      tableView: '表格视图',
      emptyTree: '解析 JSON 后将显示树状结构',
      emptyTable: '解析 JSON 后将显示表格',
      noArrayData: '当前 JSON 不包含可表格化的数组数据',
      items: '项',
      root: '根节点',
    },

    // 树节点
    tree: {
      object: '对象',
      array: '数组',
      items: '{count} 项',
      properties: '{count} 个属性',
      empty: '空',
      innerJson: '内层JSON',
      parseInner: '解析内层',
      copyValue: '复制值',
      copyPath: '复制路径',
    },

    // 表格
    table: {
      index: '序号',
      key: '键',
      value: '值',
      type: '类型',
      expand: '展开',
      collapse: '折叠',
      nestedTable: '嵌套表格',
      viewDetails: '查看详情',
    },

    // 错误面板
    error: {
      parseError: '解析失败',
      suggestion: '修复建议',
      fixAndRetry: '一键修复',
      commonErrors: {
        unexpectedToken: '意外的字符',
        unterminatedString: '未闭合的字符串',
        invalidNumber: '无效的数字格式',
        trailingComma: '尾随逗号',
        singleQuotes: '使用了单引号',
        missingQuotes: '键名缺少引号',
        invalidEscape: '无效的转义字符',
      },
    },

    // 历史记录
    history: {
      title: '历史记录',
      empty: '暂无历史记录',
      clearAll: '清空全部',
      confirmClear: '确定要清空所有历史记录吗？',
      loadRecord: '加载此记录',
      deleteRecord: '删除此记录',
      timeAgo: {
        justNow: '刚刚',
        minutesAgo: '{count} 分钟前',
        hoursAgo: '{count} 小时前',
        daysAgo: '{count} 天前',
      },
    },

    // 功能说明
    features: {
      title: '功能说明',
      tips: '使用技巧',
      highlights: '功能亮点',
      innerJson: {
        title: '内层 JSON 解析',
        desc: '自动识别 JSON 字符串中嵌套的 JSON 并展开解析，常见于日志分析、API 响应中的转义数据。',
        short: '嵌套的 JSON 字符串自动识别展开',
      },
      tableView: {
        title: '表格视图',
        desc: '对象数组以表格形式展示，支持嵌套表格，像 Excel 一样浏览和对比数据。',
        short: '数组数据像 Excel 一样浏览，支持嵌套',
      },
      nodeDetail: {
        title: '节点详情',
        desc: '折叠输入框后，点击任意节点可查看完整值，适合查看长文本或复杂嵌套对象。',
        short: '折叠输入框后点击节点查看完整值',
      },
      multiTab: {
        title: '多标签页',
        desc: '支持同时打开多个 JSON 实例，右键标签可快速管理（关闭其他/左侧/右侧）。',
        short: '同时处理多个 JSON，右键管理标签',
      },
      historyRecord: {
        title: '历史记录',
        desc: '点击左上角「历史」按钮可查看和恢复之前解析过的 JSON。',
        short: '自动保存解析历史，随时恢复',
      },
      smartFix: {
        title: '智能修复',
        desc: '解析失败时会提供修复建议，一键修复常见格式问题。',
      },
      doubleClickRename: {
        title: '双击标签',
        desc: '可重命名标签，方便区分不同的 JSON 数据。',
      },
      middleClickClose: {
        title: '中键关闭',
        desc: '鼠标中键点击标签可快速关闭（浏览器标准操作）。',
      },
    },

    // 自动命名
    autoName: {
      apiResponse: 'API响应',
      listItems: '列表({count}项)',
      userData: '用户数据',
      orderData: '订单数据',
      productData: '商品数据',
      listData: '列表数据',
    },
  },

  // 时间戳工具
  timestamp: {
    title: '时间戳转换',
    currentTime: '当前时间',
    timestamp: '时间戳',
    datetime: '日期时间',
    convert: '转换',
    swap: '交换',

    input: {
      timestampPlaceholder: '输入时间戳...',
      datetimePlaceholder: '输入日期时间...',
      selectTimezone: '选择时区',
    },

    output: {
      seconds: '秒',
      milliseconds: '毫秒',
      localTime: '本地时间',
      utcTime: 'UTC 时间',
      iso8601: 'ISO 8601',
      relative: '相对时间',
    },

    unit: {
      auto: '自动检测',
      seconds: '秒 (s)',
      milliseconds: '毫秒 (ms)',
    },

    format: {
      title: '日期格式',
      custom: '自定义格式',
    },

    timezone: {
      local: '本地时区',
      utc: 'UTC',
    },

    relative: {
      now: '现在',
      secondsAgo: '{count} 秒前',
      minutesAgo: '{count} 分钟前',
      hoursAgo: '{count} 小时前',
      daysAgo: '{count} 天前',
      weeksAgo: '{count} 周前',
      monthsAgo: '{count} 月前',
      yearsAgo: '{count} 年前',
      secondsLater: '{count} 秒后',
      minutesLater: '{count} 分钟后',
      hoursLater: '{count} 小时后',
      daysLater: '{count} 天后',
      weeksLater: '{count} 周后',
      monthsLater: '{count} 月后',
      yearsLater: '{count} 年后',
    },

    error: {
      invalidTimestamp: '无效的时间戳',
      invalidDatetime: '无效的日期时间格式',
    },

    features: {
      title: '功能说明',
      currentTimeDesc: '实时显示当前时间的时间戳和日期格式',
      bidirectional: '双向转换',
      bidirectionalDesc: '支持时间戳转日期、日期转时间戳',
      multiFormat: '多格式支持',
      multiFormatDesc: '支持秒级和毫秒级时间戳',
      copy: '一键复制',
      copyDesc: '快速复制转换结果',
    },
  },

  // SEO
  seo: {
    // 网站整体
    site: {
      title: 'DevToolkit - 在线开发者工具箱 | JSON格式化 & Go Struct转换 & 时间戳转换',
      description: '免费在线开发者工具箱：JSON格式化/解析/Postman风格表格展示、Go Struct与JSON双向转换、时间戳转换。支持内层JSON解析、多标签页、智能修复等独特功能。无需安装Postman即可使用表格视图。',
      keywords: 'JSON格式化,JSON解析器,Postman JSON,JSON在线工具,JSON表格展示,Postman风格,Go Struct转JSON,JSON转Go Struct,时间戳转换,在线开发工具,程序员工具箱',
    },
    // JSON 工具页面
    json: {
      title: 'JSON格式化工具 - Postman风格表格视图/在线解析 | DevToolkit',
      description: '强大的在线JSON格式化工具：采用Postman风格的表格视图，支持树状视图、内层JSON解析、多标签页对比、智能错误修复。无需安装Postman，在线免费使用，开发者必备。',
      keywords: 'JSON格式化,JSON解析,Postman JSON,JSON表格视图,Postman风格,JSON树状图,JSON美化,JSON压缩,在线JSON工具,JSON查看器,类似Postman',
    },
    // 时间戳工具页面
    timestamp: {
      title: '时间戳转换器 - Unix时间戳在线转换 | DevToolkit',
      description: '在线时间戳转换工具：支持秒级/毫秒级时间戳与日期时间双向转换，多时区支持，实时显示当前时间戳。',
      keywords: '时间戳转换,Unix时间戳,时间戳在线转换,日期转时间戳,时间戳转日期,毫秒时间戳',
    },
    // Go Struct 工具页面
    gostruct: {
      title: 'Go Struct与JSON互转 - 在线Go结构体生成器 | DevToolkit',
      description: '在线Go Struct与JSON双向转换工具：支持Go结构体转JSON示例、JSON自动生成Go结构体，支持嵌套结构体、多结构体定义。Go开发者必备。',
      keywords: 'Go Struct转JSON,JSON转Go Struct,Go结构体生成器,Go JSON转换,Golang工具,Go开发工具',
    },
    // Open Graph
    og: {
      siteName: 'DevToolkit 开发者工具箱',
      type: 'website',
      imageAlt: 'DevToolkit - 在线开发者工具箱',
    },
    // 结构化数据
    structured: {
      appName: 'DevToolkit 开发者工具箱',
      appDescription: '免费在线开发者工具箱，提供JSON格式化、Go Struct转换、时间戳转换等实用工具',
      appCategory: '开发工具',
      features: {
        jsonFormatter: 'JSON格式化与解析',
        jsonTable: 'JSON表格展示',
        jsonTree: 'JSON树状视图',
        innerJson: '内层JSON解析',
        multiTab: '多标签页支持',
        smartFix: '智能错误修复',
        goStructConvert: 'Go Struct双向转换',
        timestampConvert: '时间戳转换',
      },
    },
  },

  // Go 结构体工具
  gostruct: {
    title: 'Go ↔ JSON',
    goToJson: 'Go → JSON',
    jsonToGo: 'JSON → Go',
    convert: '转换',
    swap: '交换',

    input: {
      goPlaceholder: '输入 Go 结构体定义...',
      jsonPlaceholder: '输入 JSON...',
      structName: '结构体名称',
    },

    output: {
      jsonResult: 'JSON 结果',
      goResult: 'Go 结构体',
      copyResult: '复制结果',
    },

    options: {
      title: '选项',
      omitempty: '添加 omitempty',
      inlineStruct: '内联嵌套结构体',
      usePointer: '使用指针类型',
    },

    history: {
      title: '历史记录',
      goHistory: 'Go 结构体历史',
      jsonHistory: 'JSON 历史',
    },

    error: {
      invalidGo: '无效的 Go 结构体定义',
      invalidJson: '无效的 JSON 格式',
      parseError: '解析失败',
    },

    features: {
      title: '功能说明',
      tips: '使用技巧',
      goToJsonDesc: '将 Go 结构体定义转换为对应的 JSON 示例',
      jsonToGoDesc: '根据 JSON 数据自动生成 Go 结构体定义',
      tagSupport: '标签支持',
      tagSupportDesc: '自动生成 json 标签，支持 omitempty 选项',
      nestedSupport: '嵌套支持',
      nestedSupportDesc: '支持复杂的嵌套结构体转换',
      typeInference: '类型推断',
      typeInferenceDesc: '根据 JSON 值自动推断合适的 Go 类型',
      multiStruct: '多结构体',
      multiStructDesc: '支持同时定义多个相关结构体',
    },

    examples: {
      simpleStruct: '简单结构体',
      nestedStruct: '嵌套结构体',
      arrayStruct: '数组结构体',
    },
  },
};

export default zh;
